var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"anchor",on:{"click":function($event){return _vm.$handleScrollTo(_vm.params.selector, _vm.params.indent)}}},[_vm._v(" "+_vm._s(_vm.params.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }